module.exports = __webpack_public_path__ + "img/check.cbbdea10.png";